<template>
	<div class="grid-flex-container pa-4">
		<v-container class="py-6" fluid>
			<v-row>
				<div style="flex-grow: 1">
					<v-text-field
						v-if="canView"
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<v-btn v-if="canAdd" color="primary" @click="onAdd()">
					<v-icon> mdi-plus</v-icon>
					&nbsp;&nbsp;Add
				</v-btn>
			</v-row>
		</v-container>
		<div class="generic-grid-container">
			<v-data-table
				v-if="canView"
				dense
				:items="staticFields"
				:headers="headers"
				:search.sync="search"
				:loading="loading"
				disable-pagination
				fixed-header
				hide-default-footer
				loading-text="Loading..."
			>
				<template v-slot:[`item.actions`]="{ item }">
					<v-btn
						v-if="canEdit"
						fab
						small
						icon
						elevation="1"
						class="action-btn"
						@click.stop="onEdit(item)"
					>
						<v-icon color="primary" small>mdi-pencil</v-icon>
					</v-btn>
					<v-btn
						v-if="canDelete"
						fab
						small
						icon
						elevation="1"
						class="action-btn"
						@click.stop="onDelete(item.Id)"
					>
						<v-icon color="error" small>mdi-delete</v-icon>
					</v-btn>
				</template>
			</v-data-table>
		</div>
		<activity-static-field-modal
			:showDialog="showDialog"
			@close="onModalClose()"
		/>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ActivityStaticFieldsActions } from '../../../../store/actions';
import { ActivityStaticFieldsGetters } from '../../../../store/getters';
import ActivityStaticFieldModal from './ActivityStaticFieldModal.vue';
import permissionsMixin from '../../../../mixins/permissionsMixin';
import { Permissions } from '../../../../enums/permissionsEnum';

export default {
	name: 'ActivityStaticFields',
	components: { ActivityStaticFieldModal },

	mixins: [permissionsMixin],
	data() {
		return {
			search: '',
			showDialog: false,
			headers: [
				{ text: 'Name', value: 'Name' },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
		};
	},
	computed: {
		...mapGetters({
			staticFields: [ActivityStaticFieldsGetters.STATIC_FIELDS],
			loading: [ActivityStaticFieldsGetters.LOADING],
		}),
		canView() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.StaticFields.View,
			]);
		},
		canAdd() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.StaticFields.Add,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.StaticFields.Edit,
			]);
		},
		canDelete() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.StaticFields.Delete,
			]);
		},
	},
	mounted() {
		this.$store.dispatch(
			ActivityStaticFieldsActions.LOAD_STATIC_FIELDS,
			this.$route.params.id
		);
	},
	destroyed() {
		this.$store.dispatch(ActivityStaticFieldsActions.CLEAR);
	},
	methods: {
		onAdd() {
			this.showDialog = true;
		},
		onEdit(item) {
			this.$store
				.dispatch(
					ActivityStaticFieldsActions.SET_SELECTED_STATIC_FIELD,
					item
				)
				.then(() => {
					this.showDialog = true;
				});
		},
		onDelete(id) {
			this.$store.dispatch(
				ActivityStaticFieldsActions.DELETE_STATIC_FIELD,
				id
			);
		},
		onModalClose() {
			this.showDialog = false;
		},
	},
};
</script>
